import _typeof from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/typeof.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
export default {
  name: 'pc-goods-card',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '商品组',
          icon: 'el-icon-goods',
          name: 'goodsgroup',
          content: {
            title: '最新发布',
            link: {},
            data: []
          },
          config: [{
            label: '标题',
            name: 'title',
            type: 'input',
            value: ''
          }, {
            label: '更多链接',
            name: 'link',
            type: 'link',
            value: ''
          }, {
            label: '商品数据',
            name: 'data',
            type: 'goods-select',
            value: []
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      list: []
    };
  },
  computed: {},
  created: function created() {
    if (this.widgets.content.data) {
      var data = this.widgets.content.data[0];
      if (_typeof(data) != 'object') {
        this.getItem();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    getItem: function getItem() {
      var _this = this;
      var idList = this.widgets.content.data;
      var ids = this.list.map(function (item) {
        return item.id;
      });
      if (!this.isEqual(ids, idList)) {
        if (idList && idList.length) {
          this.apiPost('/bbb/goodsInfo/listData', {
            idList: idList,
            sortByParamId: true
          }).then(function (res) {
            var jsonArray = res.data;
            _this.list = jsonArray;
          });
        }
      }
    },
    handleLink: function handleLink(item) {
      var activeId = item.marketingGeneral.fullCutRuleList.map(function (item) {
        return item.ruleId;
      }).join(',');
      if (activeId) {
        this.addTrack('campaign_product_click', {
          userId: this.$store.state.userInfo.userId,
          goodsId: item.id,
          activeId: activeId,
          labelId: ''
        });
      }
    }
  }
};